/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportSystemDataSource {
    NONE = 'none',
    STOCKS_ENTRIES = 'stocksEntries',
    STOCKS_INQUIRIES = 'stocksInquiries',
}
